import { DefaultValues } from 'react-hook-form'
import { InferType, object, string } from 'yup'

import { requiredMessage } from 'directFlow/state/config/content'
import { Page } from 'directFlow/types'

export const previousCancellationYearDefaultValues = {
  previousInsuranceCancelledYear: undefined,
} satisfies DefaultValues<PreviousCancellationYearSchemaType>

const currentYear = new Date().getFullYear()

export const previousCancellationYearSchema = object({
  previousInsuranceCancelledYear: string().when(
    [
      `$${Page.PREVIOUS_CANCELLATION}.previousInsuranceCancelled`,
      `$${Page.PREVIOUS_CANCELLATION}.wasCancelledByPolicyOwner`,
      `$${Page.DRIVERS}.additionalDrivers.list`,
    ],
    {
      is: (
        previousInsuranceCancelled: boolean,
        wasCancelledByPolicyOwner: boolean,
        additionalDrivers: [],
      ) =>
        (previousInsuranceCancelled && wasCancelledByPolicyOwner) ||
        (previousInsuranceCancelled && additionalDrivers?.length === 0),
      then: () =>
        string()
          .required(requiredMessage)
          .matches(/^\d{4}$/, 'Please enter a valid year')
          .test('valid-year', 'Please enter a valid year', (value) => {
            const year = parseInt(value || '', 10)
            return year >= 1900 && year <= currentYear
          }),
      otherwise: () => string().nullable().optional(),
    },
  ),
})

export type PreviousCancellationYearSchemaType = InferType<typeof previousCancellationYearSchema>
